import { call, put, takeLatest } from "redux-saga/effects";
import { addGuestByGuestApi, getGuestApi, getGuestMailApi } from "../../services/api/users";
import { REQUEST_API_ADD_GUEST, REQUEST_API_GUEST, REQUEST_API_GUESTS, REQUEST_API_GUEST_MAIL, receiveApiData } from "../actions/actions";

function* getGuestMail({ data: { id, token } }) {
  try {
    const response = yield call(getGuestMailApi, id, token);
    if (response.data) {
      yield put(receiveApiData({ mail: response.data["guest"], validated: response.data["validatedByGuest"] }));
    } else {
      window.location.replace(`${process.env.REACT_APP_BASE_API}home`);
    }
  } catch (e) {
    console.log(e);
  }
}
function* addGuestByGuest({ data: { body, callback } }) {
  try {
    // do api call
    const res = yield call(addGuestByGuestApi, body);
    const { status } = res;
    callback(status || res.response.status);
  } catch (e) {
    console.log(e);
  }
}
function* getGuest({ data: { id, callback } }) {
  try {
    const response = yield call(getGuestApi, id);
    if (response.data) {
      yield put(receiveApiData({ guest: response.data }));
      if (callback) {
        callback();
      }
    } else {
      window.location.replace(`${process.env.REACT_APP_BASE_API}home`);
    }
  } catch (e) {
    console.log(e);
  }
}
function* getGuests() {
  try {
    const response = yield call(getGuestApi);
    if (response.data) {
      yield put(receiveApiData({ guest: response.data }));
    } else {
      window.location.replace(`${process.env.REACT_APP_BASE_API}home`);
    }
  } catch (e) {
    console.log(e);
  }
}

/*
  Alternatively you may use takeLatest.
  Does not allow concurrent fetches of Companie. If "COMPANIE_FETCH_REQUESTED" gets
  dispatched while a fetch is already pending, that pending fetch is cancelled
  and only the latest one will be run.
*/

export function* getGuestMailSaga() {
  yield takeLatest(REQUEST_API_GUEST_MAIL, getGuestMail);
}
export function* getGuestSaga() {
  yield takeLatest(REQUEST_API_GUEST, getGuest);
}
export function* getGuestsSaga() {
  yield takeLatest(REQUEST_API_GUESTS, getGuests);
}
export function* addGuestByGuestSaga() {
  yield takeLatest(REQUEST_API_ADD_GUEST, addGuestByGuest);
}
